import cls from "../../builder/Button/FormModal/formModal.module.scss";
import React, {FC, LegacyRef, ReactNode, useEffect, useRef} from "react";
import {CloseSvg} from "../../../svg";
import {useDispatch} from "react-redux";
import {openModalLayoutAction} from "../../../store/general";

interface IProps {
    title?: string;
    close: () => void;
    children: ReactNode
}

const ModalLayout:FC<IProps> = ({ title, close, children }) => {
    const modalRef = useRef<Node>(null);
    const dispatch = useDispatch();
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as HTMLDivElement)) {
                dispatch(openModalLayoutAction(false));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [])
    return (
        <div className={cls.popup_pos}>
            <div className={`${cls.main_popup} ${title ? cls.main_popup_title : ""}`} ref={modalRef as LegacyRef<HTMLDivElement>}>
                {title ? (
                    <div className={cls.main_popup_header}>
                        <span>{title}</span>
                        <CloseSvg
                            style={{width: "20px", height: "20px", cursor: "pointer"}}
                            onClick={() => close()}
                        />
                    </div>
                ) : <CloseSvg
                    style={{float: "right", width: "20px", height: "20px", cursor: "pointer"}}
                    onClick={() => close()}
                />}
                <div className={cls.main_popup_product_wrapper}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default ModalLayout;